import { ChainErrorModule } from '@injectivelabs/exceptions';
export * from './gov.js';
export * from './wasm.js';
export * from './staking.js';
export * from './exchange.js';
export * from './insurance.js';
export * from './permissions.js';
export const ChainModule = { ...ChainErrorModule };
